{
  "salon-search-form": {
    "buttons": {
      "customize": "Bộ lọc nâng cao",
      "search": "TÌM KIẾM"
    },
    "text": {
      "city": "Thành phố",
      "date": "Ngày",
      "treatment": "Dịch vụ"
    }
  }
}
